var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconAnimated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .strokes {\n                fill: none;\n                stroke-linejoin: round;\n                stroke-linecap: round;\n                stroke: #0e2c66;\n                stroke-width: 4px;\n                stroke-dasharray: 230;\n                opacity: 0;\n                animation: strokes 0.9s linear infinite, show 1s linear forwards;\n            }\n\n            @keyframes show {\n                to {\n                    opacity: 1;\n                }\n            }\n\n            @keyframes strokes {\n                to {\n                    stroke-dashoffset: 460;\n                }\n            }\n\n            .logo {\n                opacity: 1;\n                animation: smosh 1.5s linear forwards;\n            }\n\n            @keyframes smosh {\n                to {\n                    opacity: 0.2;\n                }\n            }\n\n            .front-trigale {\n                fill: #001540;\n            }\n\n            .behind-triangle {\n                fill: #0e2c66;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.13, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "strokes"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "arround",
    points: "20.37 374.5 61.12 303.9 1.87 303.9 176.13 2 350.4 303.9 291.02 303.9 331.8 374.5 20.37 374.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "footer",
    points: "75.7 342.6 98.04 303.9 254.3 303.9 276.67 342.6 75.7 342.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "triagle",
    points: "118.59 268.3 176.13 168.6 233.74 268.3 118.59 268.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lookout",
    points: "270.46 268.3 176.03 104.8 81.66 268.3 63.5 268.3 176.13 73.2 288.76 268.3 270.46 268.3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.68 -0.71)",
    className: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "behind-triangle",
    d: "M331.67,374.71H22l154.8-268.2Zm-256.1-30.9h202.7l-101.4-175.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "front-trigale",
    d: "M350.27,304.11H3.47L176.87,3.71Zm-286.9-34.6h227L176.87,72.91Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconAnimated);
export default __webpack_public_path__ + "static/media/logo-icon-animated.797bc42ae29c1a97d6dd398b7355ceff.svg";
export { ForwardRef as ReactComponent };